import { Component, inject } from '@angular/core';
import { MatIcon } from "@angular/material/icon";
import { MatListItem, MatNavList } from "@angular/material/list";
import { RouterLink } from "@angular/router";
import { TranslocoPipe } from "@jsverse/transloco";
import { DrawerUtils } from '../../../services/drawer-utils';
import {AuthService} from '../../../core/auth/auth-service';

@Component({
  selector: 'app-navbar',
  imports: [
    MatIcon,
    MatListItem,
    MatNavList,
    RouterLink,
    TranslocoPipe
  ],
  templateUrl: './navbar.html',
  styleUrl: './navbar.scss',
})
export class Navbar {
  public readonly drawerUtils = inject(DrawerUtils);
  public readonly authService = inject(AuthService);

  onClick() {
    this.drawerUtils.drawerState.set(false);
  }
}
